<template>
  <span
    :class="[
      {
        '--color-white': color === COLORS.WHITE,
        '--color-light-grey': color === COLORS.LIGHT_GREY,
        '--color-grey': color === COLORS.GREY,
        '--color-black': color === COLORS.BLACK,
        '--color-brand': color === COLORS.BRAND
      },
      'icon__detail d-flex align-items-center'
    ]"
  >
    <v-icon v-if="icon" :icon="icon" size="1.5rem" />
    <div v-else class="placeholder icon-placeholder" />
    <span v-if="content" class="ml-1 d-flex align-items-end">
      {{ content }}
      <h6>{{ subContent }}</h6>
    </span>
    <div v-else class="placeholder content-placeholder" />
  </span>
</template>

<script>
import { BLOCK_COLORS as COLORS } from "@/lib/stream-utils"

export default {
  props: {
    icon: { type: String, default: "" },
    content: { type: [String, Number], default: null },
    subContent: { type: [String, Number], default: null },
    color: { type: String, default: "" }
  },

  data() {
    return {
      COLORS
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.icon__detail {
  height: 34px;
  font-size: 16px;
  font-weight: 600;
  margin: 0.25rem 0;
  color: $color-ui--grey-70;
  line-height: 1;

  &.--color-white {
    color: $color-fixed--white;
  }

  &.--color-light-grey {
    color: $color-fixed--grey-20;
  }

  &.--color-grey {
    color: $color-fixed--grey-70;
  }

  &.--color-black {
    color: $color-fixed--black;
  }

  &.--color-brand {
    color: var(--brand-color-hex);
  }

  &:first-child {
    margin-top: 0rem;
  }

  &:last-child {
    margin-bottom: 0.5rem;
  }

  h6 {
    color: $color-ui--grey-40;
    font-size: 12px;
    margin: 0;
    margin-left: $size--1;
    margin-bottom: 1px;
  }

  .placeholder {
    height: 24px;
    border: 1px dashed $color-ui--grey-40;
    border-radius: 4px;

    &.icon-placeholder {
      width: 24px;
    }

    &.content-placeholder {
      margin-left: 8px;
      width: 80%;
    }
  }
}
</style>
